import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { getToken } from '../api/client';
import { useAuth } from '../hooks/useAuth';
import { t } from '../hooks/useT';

export function ProfilePage() {
  const { user, logout } = useAuth();

  if (!user) {
    return (
      <main className="page profile">
        <p>Connecte-toi pour voir ton profil.</p>
        <Link to="/login">Connexion</Link>
      </main>
    );
  }

  return (
    <main className="page profile">
      <h1>{user.displayName}</h1>
      <p>{user.email}</p>
      <p>{t('profile.streak')} : <strong>{user.streak}</strong></p>
      <button type="button" className="btn ghost" onClick={logout}>Déconnexion</button>
      <Link to="/leaderboard">Classement</Link>
    </main>
  );
}

export function AdminPage() {
  const { user } = useAuth();
  const [answer, setAnswer] = useState('');
  const [aliases, setAliases] = useState('');
  const [publishDate, setPublishDate] = useState('');
  const [file, setFile] = useState<File | null>(null);
  const [msg, setMsg] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!file) return;
    const fd = new FormData();
    fd.append('image', file);
    fd.append('answer', answer);
    fd.append('aliases', aliases);
    if (publishDate) fd.append('publishDate', publishDate);

    const token = getToken();
    const res = await fetch('/api/admin/puzzles', {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      body: fd,
    });
    const data = await res.json();
    if (!res.ok) {
      setMsg(data.error || 'Erreur');
      return;
    }
    setMsg(`Créé : ${data.slug}`);
  };

  if (!user) {
    return <main className="page admin"><p>Admin — connexion requise.</p></main>;
  }

  return (
    <main className="page admin">
      <h1>Admin énigmes</h1>
      <form onSubmit={handleSubmit} className="admin-form">
        <label>Image<input type="file" accept="image/*" onChange={(e) => setFile(e.target.files?.[0] || null)} required /></label>
        <label>Réponse<input value={answer} onChange={(e) => setAnswer(e.target.value)} required /></label>
        <label>Alias (virgules)<input value={aliases} onChange={(e) => setAliases(e.target.value)} /></label>
        <label>Date publication<input type="date" value={publishDate} onChange={(e) => setPublishDate(e.target.value)} /></label>
        <button type="submit" className="btn primary">Publier</button>
      </form>
      {msg && <p>{msg}</p>}
    </main>
  );
}
